module.exports = __webpack_public_path__ + "static/media/Camplete TruePath.6ba8d7aa.png";